import { render } from "./block-view-drawer.vue?vue&type=template&id=304ce82f&ts=true"
import script from "./block-view-drawer.vue?vue&type=script&lang=ts"
export * from "./block-view-drawer.vue?vue&type=script&lang=ts"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__